import PropTypes from "prop-types";
import React from "react";

import { EditButton, Info, Inside, Nickname, Number } from "./styledComponents";

export default function WePayACHEntry({
  cardType,
  handleEditButtonClick,
  last4,
}) {
  return (
    <Inside>
      <Nickname>
        {cardType[0].toUpperCase() + cardType.slice(1)} Account
      </Nickname>
      <Info onClick={handleEditButtonClick}>
        <Number>&bull; &bull; &bull; &bull; {last4}</Number>
        <EditButton
          key="edit_button"
          whileHover={{ scale: 1.1, color: "#278dc1" }}
          whileTap={{ scale: 0.95 }}
          exit={{
            opacity: 0,
            scale: 0.6,
            transition: { type: "tween" },
          }}
        >
          <div className="fas fa-pencil-alt" />
        </EditButton>
      </Info>
    </Inside>
  );
}

WePayACHEntry.propTypes = {
  cardType: PropTypes.string,
  handleEditButtonClick: PropTypes.func,
  last4: PropTypes.string,
};
